import { collection, CollectionReference, DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions, WithFieldValue } from "firebase/firestore";
import { db } from "./config/firebase";
import { Activity, LiveFeedElement, Team } from "./types";

export const getUsername = () => {
  return window.localStorage.getItem("username");
};

export const getTeamname = (id: string) => {
  if(id === "lag1") {
    return "Team Ham"
  } else {
    return "Team Burger"
  }
}

export const isLoggedIn = () => {
  return !!window.localStorage.getItem("username");
};

/* 
-------------------
--- ACTIVITY COLLECTION REFERANCE ---
-------------------
*/

const activityConverter: FirestoreDataConverter<Activity> = {
  toFirestore(activity: WithFieldValue<Activity>): DocumentData {
    const { id, ref, ...rest } = activity;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): Activity {
    const data = snapshot.data(options) as Activity;
    return {
      id: snapshot.id,
      ref: snapshot.ref,
      title: data.title,
      points: data.points,
      status: data.status,
      claimedBy: data.claimedBy,
      description: data.description,
    };
  },
};

export const activityRef = collection(db, "activities").withConverter(
  activityConverter
) as CollectionReference<Activity>;

/* 
-------------------
--- LIVEFEED COLLECTION REFERANCE ---
-------------------
*/

const liveFeedConverter: FirestoreDataConverter<LiveFeedElement> = {
  toFirestore(livefeedElement: WithFieldValue<LiveFeedElement>): DocumentData {
    const { ...rest } = livefeedElement;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): LiveFeedElement {
    const data = snapshot.data(options) as LiveFeedElement;
    return {
      text: data.text,
      imageUrl: data.imageUrl,
      timestamp: data.timestamp,
      type: data.type,
    };
  },
};

export const livefeedRef = collection(db, "livefeed").withConverter(
  liveFeedConverter
) as CollectionReference<LiveFeedElement>;


/* 
-------------------
--- TEAM COLLECTION REFERANCE ---
-------------------
*/

const teamConverter: FirestoreDataConverter<Team> = {
  toFirestore(team: WithFieldValue<Team>): DocumentData {
    const { teamId, ref, ...rest } = team;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): Team {
    const data = snapshot.data(options) as Team;
    return {
      teamId: snapshot.id,
      ref: snapshot.ref,
      points: data.points,
      teamName: data.teamName,
      activity: data.activity,
    };
  },
};

export const teamRef = collection(db, "teams").withConverter(
  teamConverter
) as CollectionReference<Team>;

